<style lang="scss" scoped>
  @import "../../../scss/variables";

  .product-image {
    min-height: 300px;
    background-size: cover;
    background-position: center center;
  }

  .loading-overlay {
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    position: absolute;
    padding: 30px;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    align-items: center;
    justify-content: center;
    z-index: 100;
  }

  .cart-table {
    width: 100%;

    .cell-image {
      width: 120px;
    }

    .cell-actions {
      width: 120px;
    }
  }

  .step {
    position: relative;
    padding-left: 50px;
    margin-bottom: 100px;

    .step-number {
      position: absolute;
      top: 0;
      left: 0;

      border: 2px solid $grey;
      border-radius: 32px;
      width: 32px;
      height: 32px;
      font-size: 17px;
      font-weight: bold;
      text-align: center;
      padding-top: 3px;
      color: $grey;
    }

    .step-content {
      padding-top: 5px;
    }
  }

  .hiddenfile {
    width: 0px;
    height: 0px;
    overflow: hidden;
  }

  .error-box {
    background-color: lighten($red, 50%);
    color: $red;
  }
</style>

<template>
  <div>
    <div v-if="$root.$data.cart">
      <div class="px2 mb3">
        <md-button class="md-raised right" @click="goBack()">Tilbake</md-button>
        <div class="fz24 light mt2">Fullfør bestilling</div>
        <p class="mt2 mb2">Last opp filer og se over detaljene nedenfor før du fullfører bestillingen.</p>
      </div>
      <div class="px2 mb3">

        <div class="step">
          <div class="step-number">1</div>
          <div class="step-content">

            <div class="fz24 light">Last opp filer</div>
            <p class="mt2 mb2">
              Last opp trykklare filer for produktene du skal bestille.
            </p>
            <p class="mt2 mb2">
              Om du ønsker å bestille flere varianter av et produkt (f.eks. beachflagg med to forskjellige motiver) kan du legge til flere filer på produktet.
            </p>
            <div class="fz16 bold mb2 mt3">Trykkfiler for produkter:</div>
            <div class="clearfix relative">
              <div class="loading-overlay" v-if="state.is('working')">
                <md-spinner md-indeterminate></md-spinner>
              </div>
              <div class="card rounded sh1" v-if="$root.$data.cart.items.length > 0">

                <table class="cart-table" cellpadding="0" cellspacing="0">
                  <thead>
                  <tr class="text-grey ">
                    <th class="border-bottom border-light-grey px3 py2 light left-align">Produkt</th>
                    <th class="border-bottom border-light-grey py2 light">Antall</th>
                    <th class="border-bottom border-light-grey py2 light">Handlinger</th>
                  </tr>
                  </thead>
                  <tbody v-for="(cartItem, index) in $root.$data.cart.items">
                  <tr class="@bg-light-blue">
                    <td class="p3 border-bottom border-light-grey">
                      <div class="fz24 light mb1">{{ cartItem.product.name }}</div>
                      <div>{{ cartItem.parameters_text }}</div>
                    </td>
                    <td class="border-bottom border-light-grey center">
                      {{ cartItem.quantity }}
                    </td>
                    <td class="border-bottom border-light-grey cell-actions center">
                      <md-button type="file" class="md-icon-button text-blue"
                                 @click.native="pickFile(cartItem.id, 'cart_item')">
                        <md-tooltip>Last opp ny trykkfil</md-tooltip>
                        <md-icon>file_upload</md-icon>
                      </md-button>
                      <div class="hiddenfile">
                        <input type="file" :id="'file_cart_item_'+cartItem.id"
                               @change="onFileChange($event, cartItem.id, 'cart_item')">
                      </div>
                    </td>
                  </tr>
                  <tr v-for="(attachment, attIndex) in cartItem.attachments">
                    <td class="px3 py2 bg-light-grey border-bottom border-middle-grey" colspan="2">
                      <div class="bold mb1">Vedlegg {{ attIndex + 1 }}:</div>
                      <a :href="attachment.artworks[0].href" target="_blank">{{ attachment.artworks[0].original_filename
                        }}</a>
                    </td>
                    <td class="px3 py2 bg-light-grey border-bottom border-middle-grey">
                      <md-button type="file" class="md-icon-button text-grey"
                                 @click.native="deleteAttachment(index, attachment.id, 'cart_items')">
                        <md-tooltip>Slett vedlegg</md-tooltip>
                        <md-icon>delete</md-icon>
                      </md-button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="fz16 bold mb2 mt3">Andre filer:</div>
            <div class="clearfix relative">
              <div class="loading-overlay" v-if="state.is('working')">
                <md-spinner md-indeterminate></md-spinner>
              </div>
              <div class="card rounded sh1" v-if="$root.$data.cart.items.length > 0">

                <table class="cart-table" cellpadding="0" cellspacing="0">
                  <thead>
                  <tr class="text-grey ">
                    <th class="border-bottom border-light-grey px3 py2 light left-align">Fil</th>
                    <th class="border-bottom border-light-grey py2 light">Handlinger</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(attachment, attIndex) in $root.$data.cart.attachments">
                    <td class="px3 py2 bg-light-grey border-bottom border-middle-grey">
                      <div class="bold mb1">Vedlegg {{ attIndex + 1 }}:</div>
                      <a :href="attachment.artworks[0].href" target="_blank">{{ attachment.artworks[0].original_filename
                        }}</a>
                    </td>
                    <td class="px3 py2 bg-light-grey border-bottom border-middle-grey center">
                      <md-button type="file" class="md-icon-button text-grey"
                                 @click.native="deleteAttachment(attIndex, attachment.id, 'cart')">
                        <md-tooltip>Slett vedlegg</md-tooltip>
                        <md-icon>delete</md-icon>
                      </md-button>
                    </td>
                  </tr>
                  <tr>
                    <td class="px3 py2 bg-light-grey border-bottom border-middle-grey">
                      <md-button class="md-raised" @click.native="pickFile($root.$data.cart.id, 'cart')">
                        Last opp ny fil
                      </md-button>

                      <div class="hiddenfile">
                        <input type="file" :id="'file_cart_'+$root.$data.cart.id"
                               @change="onFileChange($event, $root.$data.cart.id, 'cart')">
                      </div>

                    </td>
                    <td class="px3 py2 bg-light-grey border-bottom border-middle-grey center">

                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="step">
          <div class="step-number">2</div>
          <div class="step-content">

            <div class="fz24 light">Merknader til bestilling</div>
            <p class="mt2 mb3">
              Fyll inn eventuelle merknader du har til bestillingen.
            </p>

            <div class="card rounded sh1 mb3 p3">
              <md-input-container>
                <label>Merknader</label>
                <md-textarea v-model="notes"></md-textarea>
              </md-input-container>
            </div>
          </div>
        </div>

        <div class="step">
          <div class="step-number">3</div>
          <div class="step-content">

            <div class="fz24 light">Levering</div>
            <p class="mt2 mb3">
              Velg leveringsadresse for bestillingen.
            </p>

            <div class="card rounded sh1 mb3 p3">
              <div class="clearfix mxn3">
                <div class="col col-6 px3">
                  <div class="fz18 mb3">Velg</div>
                  <md-input-container>
                    <label for="delivery">Velg leveringsadresse</label>
                    <md-select name="delivery" id="delivery" v-model="deliveryAddress">
                      <md-subheader>Standard leveringsadresse</md-subheader>
                      <md-option :value="-1" v-if="user && user.store.post_address">{{ user.store.post_address.name }}
                      </md-option>
                      <md-subheader>Alle leveringsadresser</md-subheader>
                      <md-option v-for="(address, index) in addresses" :value="index" :key="index">
                        {{ address.address.name }}
                      </md-option>
                    </md-select>
                  </md-input-container>
                </div>
                <div class="col col-6 px3">
                  <div class="fz18 mb3">Valgt leveringsadresse:</div>
                  <div v-if="user && user.store.post_address" class="bg-light-blue p3 rounded">
                    <div class="mb2">
                      <small class="text-grey">Navn</small>
                      <div>{{ selectedAddress.name }}</div>
                    </div>
                    <div class="mb2">
                      <small class="text-grey">Adresse</small>
                      <div>{{ selectedAddress.address }}</div>
                    </div>
                    <div class="mb2">
                      <small class="text-grey">Postnummer</small>
                      <div>{{ selectedAddress.zip }}</div>
                    </div>
                    <div class="mb2">
                      <small class="text-grey">Poststed</small>
                      <div>{{ selectedAddress.city }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="step">
          <div class="step-number">4</div>
          <div class="step-content">

            <div class="fz24 light mb2">Detaljer</div>
            <div class="mb3">
              Fyll ut detaljene for bestillingen. Informasjonen blir kun brukt som intern referanse.
            </div>
            <div class="card rounded sh1 mb3 p3">
              <div class="fz18">Bestilling</div>
              <p>
                Gi bestillingen et navn. F.eks. "Banner og beachflag til Firma AS".
              </p>
              <div>
                <md-input-container :class="{'md-input-invalid': errors.hasError('title')}">
                  <label>Navn på bestilling</label>
                  <md-input v-model="title"></md-input>
                  <span class="md-error" v-if="errors.hasError('title')">{{ errors.getFirstError('title') }}</span>
                </md-input-container>
              </div>
            </div>
            <div class="card rounded sh1 mb3 p3">
              <div class="fz18">Kundeopplysninger</div>
              <p>
                Fyll inn detaljene til kunden du bestiller for.
              </p>
              <div>
                <md-input-container>
                  <label>Navn/firma</label>
                  <md-input v-model="data.client.name"></md-input>
                </md-input-container>
                <md-input-container>
                  <label>Telefon/mobil</label>
                  <md-input v-model="data.client.phone"></md-input>
                </md-input-container>
                <md-input-container>
                  <label>E-post</label>
                  <md-input v-model="data.client.email"></md-input>
                </md-input-container>
              </div>
            </div>
          </div>
        </div>

        <div class="step">
          <div class="step-number">5</div>
          <div class="step-content">
            <div class="fz24 light mb3">Fullfør</div>
            <div class="card rounded sh1 mb3 p3">
              <div class="fz18">Oppsummering</div>
              <p class="mt2">
                Se over besillingen før du fullfører:
              </p>

              <table class="cart-table" cellpadding="0" cellspacing="0">
                <thead>
                <tr class="text-grey ">
                  <th class="border-bottom border-light-grey "></th>
                  <th class="border-bottom border-light-grey py2 light left-align">Produkt</th>
                  <th class="border-bottom border-light-grey py2 light">Antall</th>
                  <th class="border-bottom border-light-grey py2 light left-align">Pris pr. stk.</th>
                  <th class="border-bottom border-light-grey py2 light left-align" light>Total</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(cartItem, index) in $root.$data.cart.items" class="@bg-light-blue">
                  <td class="cell-image p2">
                    <img class="rounded pointer" :src="getThumbnail(cartItem.product)" width="80" height="80"/>
                  </td>
                  <td>
                    <div class="fz18 mb1">{{ cartItem.product.name }}</div>
                    <div>{{ cartItem.parameters_text }}</div>
                  </td>
                  <td class="center px3">
                    {{ cartItem.quantity }}
                  </td>
                  <td>
                    <div class="fz24 light text-grey truncate">kr {{ toLocale(cartItem.unit_price / 100) }},-</div>
                  </td>
                  <td>
                    <div class="fz24 light text-blue truncate">kr {{ toLocale(cartItem.total / 100) }},-</div>
                  </td>
                </tr>
                <tr>
                  <td class="border-top border-light-grey"></td>
                  <td class="border-top border-light-grey"></td>
                  <td class="border-top border-light-grey"></td>
                  <td class="border-top border-light-grey">
                    <div class="fz24 light mb1 text-grey pt3 truncate">kr {{ toLocale($root.$data.cart.vat_total / 100)
                      }},-
                    </div>
                    <div class="text-grey">MVA</div>
                  </td>
                  <td class="border-top border-light-grey pt3">
                    <div class="fz24 light mb1 text-blue truncate">kr {{ toLocale($root.$data.cart.gross_total / 100)
                      }},-
                    </div>
                    <div class="text-grey">Total</div>
                  </td>
                </tr>
                </tbody>
              </table>

            </div>
            <div class="card rounded sh1 mb3 p3">
              <div class="fz18">Betingelser</div>
              <p class="mt2">
                Leveringstid er normalt 10-14 arbeidsdager. Alle bestillinger vil bli belastet med frakt og hånderingsgebyr
                på 600 kr for mindre ordre (under 90x120x10 cm) og 1 200 kr for større ordre.
              </p>
            </div>
            <div class="error-box p3 rounded sh1 mb3" v-if="errors.hasErrors()">
              <div class="fz18 mb1">Feil i felter</div>
              <div>Vennligst se over besillingen og prøv på nytt. Fant følgende feil i bestilling:</div>
              <ul class="m0 mt2">
                <li v-for="error in errors.errors" class="fz16">{{ error[0] }}</li>
              </ul>
            </div>
            <md-button class="md-raised md-success m0 px3 py1 mt2" @click.native="placeOrder()"
                       :disabled="state.is('ordering')">
              <span v-if="state.is('ordering')">Plasserer din besilling...</span>
              <span v-else>Fullfør og plasser bestilling</span>
            </md-button>
          </div>
        </div>

      </div>
    </div>
    <div class="p3 center" v-else>
      <md-spinner md-indeterminate></md-spinner>
    </div>
  </div>
</template>

<script>
  import apiOrder from '@/js/api/order';
  import apiCart from '@/js/api/cart';
  import apiCartItem from '@/js/api/cartItem';
  import apiAttachment from '@/js/api/attachment';
  import apiDeliveryAddress from '@/js/api/deliveryAddress';
  import apiMe from '@/js/api/me';
  import State from '@/js/helpers/state';
  import Errors from '@/js/helpers/errors';
  import hasPrices from '@/js/mixins/hasPrices';
  import hasPictures from '@/js/mixins/hasPictures';

  export default {
    mixins: [hasPrices, hasPictures],

    data() {
      return {
        state: new State(),
        errors: new Errors(),
        user: null,
        title: '',
        notes: '',
        addresses: [],
        deliveryAddress: -1,
        data: {
          client: {
            name: '',
            email: '',
            phone: '',
          },
        },
      };
    },

    mounted() {
      this.state.start('working');
      apiCart.get().then(this.onCartSuccess);
      apiDeliveryAddress.index().then(this.onDeliveryAddressesSuccess);
      apiMe.show().then(this.onMeSuccess);
    },

    methods: {
      onCartSuccess(cart) {
        apiCart.show(cart.id).then(this.onFetchSuccess);
      },

      onDeliveryAddressesSuccess(response) {
        this.addresses = response.data.data;
      },

      onMeSuccess(response) {
        this.user = response.data.data;
      },

      onFetchSuccess(response) {
        this.$root.$data.cart = response.data.data;
        this.state.stop('working');
      },

      pickFile(id, type) {
        document.getElementById(`file_${type}_${id}`).click();
      },

      onFileChange(e, id, type) {
        const element = document.getElementById(`file_${type}_${id}`);

        if (element.files[0] === undefined) {
          return;
        }

        const data = new FormData();

        data.append('attachable_id', id);
        data.append('attachable_type', type);
        data.append('attachment', element.files[0]);

        this.state.start('working');

        apiAttachment.store(data).then((response) => {
          if (type === 'cart') {
            this.$root.$data.cart.attachments.push(response.data.data);
          } else {
            const index = _.findIndex(this.$root.$data.cart.items, o => o.id === id);
            this.$root.$data.cart.items[index].attachments.push(response.data.data);
          }
        }).then(() => {
          this.state.stop('working');
        });
      },

      deleteAttachment(itemIndex, id, type) {
        this.state.start('working');

        apiAttachment.remove(id).then((response) => {
          if (type === 'cart') {
            const attachments = this.$root.$data.cart.attachments;
            const index = _.findIndex(attachments, o => o.id === id);
            attachments.splice(index, 1);
          } else {
            const attachments = this.$root.$data.cart.items[itemIndex].attachments;
            const index = _.findIndex(attachments, o => o.id === id);
            attachments.splice(index, 1);
          }
        }).then(() => {
          this.state.stop('working');
        });
      },

      placeOrder() {
        const orderData = this.data;
        orderData.delivery_address = this.selectedAddress;

        const data = {
          cart_id: this.$root.$data.cart.id,
          title: this.title,
          notes: this.notes,
          data: orderData,
        };

        this.errors.clearErrors();
        this.state.start('ordering');

        apiOrder.store(data).then((response) => {
          const order = response.data;
          this.$router.push({ name: 'order-complete', params: { orderId: order.id } });
          this.state.stop('ordering');
        }).catch((error) => {
          this.errors.setErrors(error.response.data.errors);
          this.state.stop('ordering');
        });
      },

      goBack() {
        this.$router.go(-1);
      },
    },

    computed: {
      selectedAddress() {
        if (this.deliveryAddress === -1) {
          return this.user.store.post_address;
        }

        return this.addresses[this.deliveryAddress].address;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// Checkout.vue?a91254c2